import React, { useState } from 'react';
import { Typography, Box, Paper } from '@mui/material';
import FormButton from '../../Componentes/FormButton';
import IniciarSolicitudModal from '../molecules/IniciarSolicitudModal';
import { ModalGeneral } from '../../Componentes/ModalGeneral';

const IniciarSolicitud = () => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };

    return (
        <>
            <Box py={3}>
                <Paper elevation={3} sx={{ padding: '32px', maxWidth: '1000px', margin: 'auto' }}>
                    <Typography variant="h4" component="h1" gutterBottom>
                        Centro de Traducciones Académicas
                    </Typography>

                    <Typography variant="body1" paragraph>
                        En abril de 2014, la UTN Buenos Aires lanzó su Centro de Traducciones Académicas, al servicio de la comunidad
                        tecnológica para la traducción de presentaciones para jornadas, congresos o revistas de divulgación científica.
                    </Typography>

                    <Typography variant="body1" paragraph>
                        El objetivo del Centro de Traducciones Académicas es ampliar el marco de divulgación de las actividades
                        académicas y de investigación que se realizan en la Facultad. Para ello el Centro brinda servicio para la
                        producción de traducciones español-inglés / inglés-español o correcciones de trabajos inglés/inglés
                        específicamente para los siguientes tipos de producciones:
                    </Typography>

                    <Typography variant="body1" paragraph>
                        <ul>
                            <li>Presentaciones a jornadas o congresos o revistas que realice un grupo de investigación en el marco de un PID</li>
                            <li>Presentaciones a jornadas o congresos o revistas que realice un alumno de posgrado en el marco de una tesis de Maestría o Doctorado</li>
                            <li>Presentaciones a jornadas o congresos o revistas que realice uno o más docentes en el marco de su actividad como profesor de la casa</li>
                            <li>Documentos de divulgación científica o técnica con impacto en la docencia o la investigación</li>
                        </ul>
                    </Typography>

                    <Typography variant="body1" paragraph>
                        El tiempo estimado para la devolución del trabajo es de aproximadamente 15 días. La Secretaría Académica
                        organizará las prioridades de los trabajos a traducir en función de factores relacionados con los tiempos para
                        la presentación, la pertenencia o no a un PID, el largo del documento y todo otro factor que esté relacionado
                        con el impacto institucional. También dependerá de la dificultad técnica en la realización de la traducción.
                    </Typography>
                    <Box display="flex" justifyContent="center" mt={3}>
                        <FormButton text={'Crear Solicitud'} onClick={handleOpenModal} />
                    </Box>
                </Paper>
            </Box>

            <ModalGeneral
                Contenido={<IniciarSolicitudModal onClose={handleCloseModal} />}
                open={modalOpen}
                onClose={handleCloseModal}
                titulo={"Solicitud de Traducción"}
            />
        </>
    );
};

export default IniciarSolicitud;
